import React from 'react';

export const FrenchGirlIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g strokeLinecap="butt" strokeLinejoin="miter" strokeOpacity="1">
                <path
                    fill="#fff"
                    fillOpacity="1"
                    stroke="none"
                    strokeWidth="0.265"
                    d="M1.047 2.099c2.356-.554 4.245-.718 4.245-.718S5.819.377 5.027.322c-.843-.057-2.01-.04-3.001.53-.38.22.024.428-.533.2-.127-.052-1.465.35-1.407.904.132.446.42.223.96.143z"
                ></path>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    stroke="none"
                    strokeWidth="0.265"
                    d="M2.859.637C1.976.433 1.42.082 1.579.322c.157.24.345.754.345.754z"
                ></path>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    stroke="none"
                    strokeWidth="1"
                    d="M18.5 6.813C15.812 6.875 6.156 8.5 2.719 10c0 0-.375-.219-.813 1.875C1.436 14.125 2 19 2 19h6.844c-1.304-.987-2.904-2.532-4.625-5.05-.285-.417-.074-.429-.074-.429s-1.532.795 3.074-1.572c4.5-2.312.437-3.812 7-.062 5.109 2.92 4.812-2.313 4.375 1.75-.184 1.707-2.238 3.89-4.045 5.363H22s.094-.5-.031-3.188c-.125-2.687-.782-9.062-3.469-9z"
                    opacity="1"
                    transform="scale(.26458)"
                ></path>
                <path
                    fill="none"
                    stroke="#fff"
                    strokeWidth="0.265"
                    d="M3.164 5.444c.248 0 1.69-1.104 1.77-1.852.115-1.075.194.309-1.158-.464-1.736-.992-.661-.595-1.852.017-1.219.626-.813.416-.813.416s-.056.003.02.113c1.095 1.603 2.033 1.77 2.033 1.77z"
                ></path>
            </g>
        </svg>
    );
};
